import { PlatformDependent } from '@/components/PlatformDependent'
import { OddsDataViewDDE } from '@/views/GolfPricing/Tournament/OddsData/OddsDataView.dde'

const OddsDataView = () => (
  <>
    <PlatformDependent dde>
      <OddsDataViewDDE />
    </PlatformDependent>
  </>
)

export default OddsDataView
